module.exports = __webpack_public_path__ + "img/introducePageEight_show_one.09e59e95.jpeg";